<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<h1 mat-dialog-title>New survey</h1>
<mat-dialog-content>
  <form [formGroup]="surveyTitleForm">
    <p>Please enter the survey title to get started.</p>
    <mat-form-field class="title-input">
      <input matInput formControlName="title" autocomplete="off" />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    class="create-survey-btn"
    [disabled]="!surveyTitleForm.value['title']"
    (click)="onCreateSurvey()"
  >
    Create survey
  </button>
</mat-dialog-actions>
